import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TwitterIcon/></a>
        <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TelegramIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;